import { MakeCall } from './createMakeCall';
import { BookingModificationDetails } from './types/BookingModificationDetails';

// fetch booking modification details for LL and tenant based on conversation id
const getBookingModificationById =
  (makeCall: MakeCall) => (conversationId: number) =>
    makeCall<BookingModificationDetails>(
      'GET',
      `/api/v2/conversation/${conversationId}/change`,
    );
export { getBookingModificationById };
